export const ADMIN_NAV_ITEMS = [
  {
    label: "Home",
    to: "/admin/dashboard",
    icon: "fas fa-home",
    roles: ["superadmin", "subadmin"],
  },
  {
    label: "Schools",
    icon: "fas fa-school",
    key: "schools",
    roles: ["superadmin"],
    children: [
      {
        label: "School",
        to: "/school",
        roles: ["superadmin"],
      },
      {
        label: "Agreement",
        to: "/school/agreements",
        roles: ["superadmin"],
      },
      {
        label: "Invoices",
        to: "/school/agreement/invoices",
        roles: ["superadmin"],
      },
      {
        label: "Payments",
        to: "/school/agreement/payments",
        roles: ["superadmin"],
      },
    ],
  },
  {
    label: "Students",
    to: "/student",
    icon: "fa-solid fa-users",
    roles: ["superadmin"],
  },
  {
    label: "Teachers",
    to: "/teacher",
    icon: "fa-solid fa-chalkboard-user",
    roles: ["superadmin"],
  },
  {
    label: "Parents",
    to: "/parent",
    icon: "fa-solid fa-chalkboard-user",
    roles: ["superadmin"],
  },
  {
    label: "Subscription",
    to: "/subscription",
    icon: "fa-solid fa-chalkboard-user",
    roles: ["superadmin"],
  },
  {
    label: "Coupon",
    to: "/coupon",
    icon: "fa-solid fa-tag",
    roles: ["superadmin"],
  },
  {
    label: "Quest",
    to: "/quest",
    icon: "fa-solid fa-newspaper",
    roles: ["superadmin", "subadmin"],
  },
  {
    label: "Certificate",
    to: "/certificate",
    icon: "fa-solid fa-certificate",
    roles: ["superadmin", "subadmin"],
  },
  {
    label: "Trophy",
    to: "/trophy",
    icon: "fa-solid fa-trophy",
    roles: ["superadmin", "subadmin"],
  },
  {
    label: "Enquires",
    to: "/form-enquires",
    icon: "fa-solid fa-chalkboard-user",
    roles: ["superadmin", "sub_admin"],
  },
  {
    label: "Referral",
    to: "/referral",
    icon: "fa-solid fa-chalkboard-user",
    roles: ["superadmin"],
  },
  {
    label: "Account",
    icon: "fas fa-info-circle",
    key: "account",
    roles: ["superadmin", "subadmin"],
    children: [
      {
        label: "Settings",
        to: "/admin/settings",
        roles: ["superadmin", "subadmin"],
      },
    ],
  },
];
